import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

const TransactionTypesContext = createContext();

export const useTransactionTypes = () => {
  const context = useContext(TransactionTypesContext);
  if (!context) {
    throw new Error('useTransactionTypes must be used within TransactionTypesProvider');
  }
  return context;
};

export const TransactionTypesProvider = ({ children }) => {
  const [transactionTypes, setTransactionTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    // Listener em tempo real para o agregado de tipos de transação
    const transactionTypesAggregateRef = doc(db, 'agregadoTiposTransacao', 'all');
    
    const unsubscribe = onSnapshot(
      transactionTypesAggregateRef,
      (snapshot) => {
        try {
          if (snapshot.exists()) {
            const data = snapshot.data();
            const typesData = data.tiposTransacao || [];
            setTransactionTypes(typesData);
          } else {
            // Se o agregado não existe, retornar array vazio (não lançar erro)
            setTransactionTypes([]);
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
        }
      },
      (error) => {
        // Callback de erro do onSnapshot
        setLoading(false);
      }
    );

    // Cleanup: remover listener quando o componente desmontar
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <TransactionTypesContext.Provider value={{
      transactionTypes,
      loading
    }}>
      {children}
    </TransactionTypesContext.Provider>
  );
};
